// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const clamperl: PokeData = {
  "id": 366,
  "name": "clamperl",
  "height": 4,
  "weight": 525,
  "base_experience": 69,
  "types": [
    PokeType.WATER
  ],
  "api_moves": [
    "water-gun",
    "clamp",
    "whirlpool",
    "iron-defense",
    "shell-smash"
  ],
  "moves": [
    "whirlpool",
    "iron-defense",
    "bubble-beam",
    "water-spout",
    "bubble",
    "aqua-cutter",
    "rain-dance",
    "brine",
    "liquidation",
    "aqua-tail",
    "aqua-jet",
    "life-dew",
    "hydro-pump"
  ],
  "evolution_chain": {
    "id": 188,
    "item": null,
    "species": [
      {
        "name": "clamperl",
        "order": 396,
        "types": [
          PokeType.WATER
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "huntail",
        "order": 397,
        "types": [
          PokeType.WATER
        ],
        "evolves_from_species_id": 366,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.TRADE
            },
            "gender": null
          }
        ]
      },
      {
        "name": "gorebyss",
        "order": 398,
        "types": [
          PokeType.WATER
        ],
        "evolves_from_species_id": 366,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.TRADE
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 52.5,
    "speed": 32,
    "ability_power": 74
  },
  "stat_changes": [],
  "catch_rate": 255,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
